export default __webpack_public_path__ + "static/media/Ballroll_00090.8efea239.png";